<template>
  <div class="idtr-block idtr-intro">{{ text.intro }}</div>
</template>

<script>
import {IDTR_TEXT} from "@/assets/constants/identity.theft.report.constants";

export default {
  data: () => ({text: IDTR_TEXT}),
};
</script>
